import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { defineCustomElements } from '@scania/tegel/loader';

// Definir custom elements do Tegel
defineCustomElements(window);

// Bootstrap tradicional com NgModule
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
